import { gql } from "@apollo/client";

export const PUBLISH_MENU_LAYOUT_MUTATION = gql`
  mutation PublishMenuLayout($input: PublishMenuLayoutInput!) {
    publishMenuLayout(input: $input) {
      statusCode
      message
      status
    }
  }
`;
